import * as actions from '../Actions/Users';

export const usersReducer = (state = {}, action) => {
      switch (action.type) {
          case actions.GET_USERS_DATA_REQUESTED:
              return { ...state, isLoading: true };
          case actions.GET_USERS_DATA_DONE:
              return { ...state, isLoading: false, users: action.payload };
          case actions.GET_USERS_DATA_FAILED:
              return { ...state, isLoading: false, isError: true, error: action.payload };
          default:
              return state;
      }
 };

